import {getUserLocale} from '@Utils/locale.util';

const numberFormatter = new Intl.NumberFormat(getUserLocale());

export const formatNumber = (toFormat: number): string => {
  return numberFormatter.format(toFormat);
};

export const formatNumberInUSD = (toFormat: number): string => {
  return window.PMW.util.currencyFormat(toFormat, window.PMW.CURRENCY_CODE_USD);
};

export const formatWholeNumberInUSD = (value: number): string => {
  return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 0}).format(value);
};

/**
 * A USD amount showing cents only when it has them: `10 → "$10"`, `10.5 → "$10.50"`. For copy that quotes a
 * configured limit, where `formatWholeNumberInUSD` would round a $10.50 threshold to "$11" and state a figure the
 * code does not enforce.
 */
export const formatExactNumberInUSD = (value: number): string => {
  const fractionDigits = Number.isInteger(value) ? 0 : 2;
  return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits}).format(value);
};

export const formatNumberInCurrency = (toFormat: number, currencyCode: string): string => {
  return window.PMW.util.currencyFormat(toFormat, currencyCode);
};

export const getRandomNumberInRange = (min: number, max: number): number => {
  return Math.random() * (max - min) + min;
};

export const formatToNearestThousand = (val: number): string => {
  if (val > 999) {
    const temp = val / 1000;
    return `${temp.toFixed(0)}k`;
  }

  return String(val);
};

export const formatToThousand = (val: number): string => {
  if (Math.abs(val) > 999) {
    const temp = Math.floor(val / 100) / 10;
    return `${temp}k`;
  }

  return String(val);
};

export const formatToMillion = (val: number): string => {
  if (Math.abs(val) > 999999) {
    const temp = Math.floor(val / 100000) / 10;
    return `${temp}M`;
  }

  return String(val);
};

export const abbreviateNumber = (val: number): string => {
  const num = Math.abs(val);
  if (num > 999999) {
    return formatToMillion(val);
  }

  if (num > 999) {
    return formatToThousand(val);
  }

  return String(val);
}
